import { getCommunityLabel } from "@/share/communityLabel";

export const PAGE_TITLES = {
  "/member/home": "Inicio",
  "/member/home/showInfo": "Mi credencial",
  "/member-v2/home": "Inicio",
  "/member-v2/profile": "Mi Perfil",
  "/member-v2/history": "Histórico y Pagos",
  "/member-v2/asocoins": "Mis Asocoins",
  "/member-v2/events": "Eventos",
  "/member-v2/votaciones": "Mis Votaciones",
  "/member-v2/events/my": "Mis inscripciones",
  "/member-v2/community": "Mi Comunidad",
  "/member-v2/benefits": "Mis Beneficios",
  "/member-v2/directory": "Directorio",
  "/member-v2/affiliates": "Submiembros",
  "/member-v2/affiliates/new": "Submiembros",
  "/sac": "Autodiagnóstico SAC",
};

export const resolvePageTitle = (path, query, user) => {
  if (!path) return "Inicio";
  if (path === "/member-v2/community" || path === "/member-v2/community/") {
    return getCommunityLabel(user);
  }
  if (PAGE_TITLES[path]) return PAGE_TITLES[path];
  if (path === "/member/home" || path === "/member/home/") return "Inicio";
  if (path.startsWith("/member/home/showInfo")) return "Mi credencial";
  if (path === "/member-v2/profile" || path === "/member-v2/profile/") return "Mi Perfil";
  if (path === "/member-v2/asocoins" || path === "/member-v2/asocoins/") return "Mis Asocoins";
  if (path === "/sac" || path === "/sac/") return "Autodiagnóstico SAC";
  if (path.startsWith("/sac/responses/") && path.endsWith("/result")) return "Resultado del Autodiagnóstico";
  if (path.startsWith("/sac/responses/")) return "Autodiagnóstico SAC";
  if (path === "/member-v2/events" || path === "/member-v2/events/") {
    return query && query.tab === "my" ? "Mis inscripciones" : "Eventos";
  }
  if (path === "/member-v2/events/my" || path === "/member-v2/events/my/") return "Mis inscripciones";
  if (path.startsWith("/member-v2/events/") && path.includes("/checkout")) return "Adquirir acceso";
  if (path === "/member-v2/votaciones" || path === "/member-v2/votaciones/") return "Mis Votaciones";
  if (path.startsWith("/member-v2/votaciones/")) return "Mis Votaciones";
  if (path.startsWith("/member-v2/events/")) return "Detalle del evento";
  if (path === "/member-v2/benefits" || path === "/member-v2/benefits/") return "Mis Beneficios";
  if (path === "/member-v2/directory" || path === "/member-v2/directory/") return "Directorio";
  if (path === "/member-v2/affiliates" || path === "/member-v2/affiliates/") return "Submiembros";
  if (path === "/member-v2/affiliates/new" || path === "/member-v2/affiliates/new/") {
    return query && query.edit ? "Editar submiembro" : "Agregar submiembro";
  }
  if (path.startsWith("/member-v2/affiliates/")) return "Submiembros";
  if (path.startsWith("/member-v2")) return "Inicio";
  return "Inicio";
};
